import API, { ensurePrefixed } from 'utils/api';
import { onError, onSuccess } from 'utils/handlers';

const BASE_URL = 'catastro/participe/';

export const formatParticipe = (_participe) => {
  const participe = { ..._participe };
  participe.porcentaje_nuevo = parseFloat(participe.porcentaje_nuevo || participe.porcentaje) || 0;
  participe.porcentaje = parseInt(participe.porcentaje_nuevo || participe.porcentaje, 10) || 0;
  return participe;
};

export const getParticipes = async (params) => {
  try {
    const response = await API.get(BASE_URL, { params });
    return response.data.map(formatParticipe);
  } catch (error) {
    onError(error);
  }
  return [];
};

export const getParticipe = async (id) => {
  try {
    const response = await API.get(`${BASE_URL}${id}/`);
    return formatParticipe(response.data);
  } catch (error) {
    onError(error);
  }
  return {};
};

export const createParticipe = async (data, accion = 'PARTICIPE') => {
  try {
    const accionInf = ensurePrefixed('CREAR_', accion);
    const response = await API.post(BASE_URL, formatParticipe(data), { accionInf });
    onSuccess(response, 'Agregado correctamente');
    return formatParticipe(response.data);
  } catch (error) {
    onError(error);
  }
  return {};
};

export const updateParticipe = async (id, data, accion = 'PARTICIPE') => {
  try {
    const accionInf = ensurePrefixed('EDITAR_', accion);
    const response = await API.patch(`${BASE_URL}${id}/`, formatParticipe(data), { accionInf });
    onSuccess(response, 'Actualizado correctamente');
    return formatParticipe(response.data);
  } catch (error) {
    onError(error);
  }
  return {};
};

export const deleteParticipe = async (id) => {
  try {
    const response = await API.delete(`${BASE_URL}${id}/`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (error) {
    onError(error);
  }
  return false;
};
